module.exports = __webpack_public_path__ + "img/question.1f49f73d.svg";